import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions';
import * as Modules from 'components/modules';
import styles from './feedbackForm.css';
import { Field, Form } from 'react-final-form';
import * as Yup from 'yup';

/* eslint-disable react/prop-types */

// const validationSchema = Yup.object().shape({
//   message: Yup.string('message').required('Нам важно ваше сообщение'),
//   phone: Yup.string('phone').required('Нам нужен ваш номер, чтобы связвться'),
//   name: Yup.string('name').required('Как к вам обращаться?'),
// });

class FeedbackForm extends React.Component {
  state = { submitted: false };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };
  onSubmit = (values) => {
    const formData = new FormData();
    formData.set('message', values.message);
    formData.set('phone', values.phone);
    formData.set('name', values.name);
    // getUserPassword(formData, true);
    this.setState(
      () => ({ submitted: true }),
      () => {
        this.timeout = setTimeout(() => {
          this.props.resetPopup();
        }, 2500);
      },
    );
  };
  // validateForm = values =>
  //   validationSchema
  //     .validate(values)
  //     .then(() => {})
  //     .catch(error => ({ [error.path]: error.message }));

  render() {
    const { submitted } = this.state;
    return submitted ? (
      <div className={styles.successMessageWrapper}>
        <h2 className={styles.successMessage}>
          Спасибо!<br /> Ваше сообщение отправлено!
        </h2>
      </div>
    ) : (
      <Form
        onSubmit={this.onSubmit}
        render={({ handleSubmit, form, submitting }) => (
          <form className={styles.form} action="" onSubmit={handleSubmit}>
            <Field
              className={styles.textArea}
              required
              name="message"
              component="textarea"
              placeholder="Напишите нам что-нибудь важное.
    Это сообщение увидит специально обученный
    человек и постарается вам ответить как  можно
    быстрее"
            />
            <Field
              className={styles.input}
              required
              name="phone"
              component="input"
              placeholder="Не забудьте написать ваш телефон или e-mail"
            />
            <Field
              className={styles.input}
              required
              name="name"
              component="input"
              placeholder="и как к вам обращаться"
            />
            <button
              type="submit"
              className={styles.submitButton}
              disabled={submitting}
            >
              Отправить
            </button>
          </form>
        )}
      />
    );
  }
}

const mapDispatch = dispatch => ({
  resetPopup: () => dispatch(actions.resetPopup()),
});

export default connect(null, mapDispatch)(FeedbackForm);



// WEBPACK FOOTER //
// ./src/components/modules/FeedbackForm/FeedbackForm.js